import gql from 'graphql-tag'




export const DELETE_TOPCOMMENT = gql`
    mutation deleteTopComment($topCommentId:String! $categoryId:String!){
        deleteTopComment(topCommentId: $topCommentId categoryId:$categoryId){
            count
        }
    }
`